/* src/app/views/template/components/templates/digital/digital-templates.component.scss */
/*# sourceMappingURL=digital-templates.component.css.map */
